export const BASE_URL = `https://miishca.github.io/react_store`;
